// Identidad de cada plataforma en SG: el mismo color en chips, barras y Excel
// para que el cuadre se lea de un vistazo. Los colores salen de los logos:
// Dumax (pin lima de assets/LogoSplash.svg), Wialon (rosa del símbolo) y Mapon
// (verde de la «o»). Dumax y Mapon son los dos verdes; los separa el tono
// (lima contra verde hoja) y el logo, que siempre va junto al color.

export type SgPlatform = "v5" | "wialon" | "mapon";

export const PLATFORMS: SgPlatform[] = ["v5", "wialon", "mapon"];

export const PLATFORM_META: Record<SgPlatform, { label: string; color: string }> = {
  v5: { label: "Dumax v5", color: "#83E449" },
  wialon: { label: "Wialon", color: "#F2295B" },
  mapon: { label: "Mapon", color: "#4C9A0E" },
};

// Sin plataforma: no está dado de alta en ninguna (cobro sin rastreo).
export const NONE_COLOR = "#9CA3AF";
export const MULTI_COLOR = "#F59E0B";
